var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell"},[_c('HeroCarousel',{attrs:{"slides":_vm.heroSlides}}),_c('ProductMenuGrid',{attrs:{"items":_vm.productCategories}}),_c('AboutShowcase',{attrs:{"stats":_vm.companyStats}}),_c('SolutionCarousel'),_c('NewsTabsCarousel',{attrs:{"source-tabs":_vm.newsTabs}}),_c('PartnerWorldMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }